import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import {
  Close,
  EventAvailable,
  FactCheckRounded,
  PlayCircleFilledRounded,
} from "@mui/icons-material";
import {
  Link as RouterLink,
  withRouter,
  LinkProps as RouterLinkProps,
} from "react-router-dom";
import { Meeting } from "components/Content/Meetings/Main/meeting";
import { Box, Stack, Typography } from "@mui/material";
import { green } from "@mui/material/colors";
import VerifiedRoundedIcon from "@mui/icons-material/VerifiedRounded";
import { useAlert } from "react-alert";
import { theme } from "components/Content/Meetings/Main/Meeting/Details/InProgress/InprogressStepper";
import { FormikProps } from "formik";
import { isNull } from "lodash";
import { CustomDialogTitle } from "components/UI/Dialog";


type Values ={

}
interface EditEventDialogProps {
  children: React.ReactNode;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  meeting: Meeting;
  isLocked: boolean;
  formRef: React.MutableRefObject<FormikProps<Values> | null>
  setIsLocked: React.Dispatch<React.SetStateAction<boolean>>;
}



function EditEventWindowDialog({
  children,
  open,
  setOpen,
  formRef,
  meeting,
  isLocked,
  setIsLocked
}: EditEventDialogProps) {
  const alert = useAlert();

  const handleSubmit = () => {
    if(isNull(formRef.current)) return;
      if ( formRef.current.dirty) {
        formRef.current.handleSubmit();
      } else {
        setOpen(false);
        alert.show("NO CHANGES MADE", { type: "info" });
      }
  };

  const LinkBehavior = React.forwardRef<any, Omit<RouterLinkProps, "to">>(
    (props, ref) =>
      meeting && meeting.id && isLocked ? (
        <RouterLink
          ref={ref}
          to={`/meetings/${meeting.id}`}
          {...props}
          role="button"
        >
          <Stack direction="row" width="100%" p={0}>
            {meeting.status === 1 ? (
              <PlayCircleFilledRounded color="success" />
            ) : meeting.status === 2 ? (
              <FactCheckRounded color="success" />
            ) : (
              <VerifiedRoundedIcon color="success" />
            )}
            <Typography
              variant="body2"
              sx={{ color: green[800], alignSelf: "center", pl: 1 }}
            >
              {meeting.status === 1
                ? "START MEETING"
                : meeting.status === 2
                ? "TAKE MINUTES"
                : meeting.status === 7
                ? "OPEN VIRTUAL MEETING"
                : "COMPLETE MEETING"}
            </Typography>
          </Stack>
        </RouterLink>
      ) : (
        <Button
          variant="contained"
          color="success"
          sx={{ mr: 1 }}
          startIcon={
            meeting.status === 1 ? (
              <PlayCircleFilledRounded />
            ) : meeting.status === 2 ? (
              <FactCheckRounded />
            ) : (
              <VerifiedRoundedIcon />
            )
          }
          disabled
        >
          {meeting.status === 1
            ? "START MEETING"
            : meeting.status === 2
            ? "TAKE MINUTES"
            : meeting.status === 7
            ? "OPEN VIRTUAL MEETING"
            : "COMPLETE MEETING"}
        </Button>
      )
  );

  React.useEffect(() => {
    return () => {
      setIsLocked(true);
    };
  }, [open, setIsLocked]);

  return (
    <Dialog
      onClose={() => setOpen(false)}
      aria-labelledby="edit-event-title"
      open={open}
      fullWidth
      maxWidth="sm"
      sx={{
        zIndex: 1500,

        "& .MuiDialogContent-root": {
          py: 3,
          px: 0,
          minWidth: 400,
        },
        "& .MuiDialogActions-root": {
          padding: theme.spacing(1),
        },
      }}
    >
      <CustomDialogTitle
        id="edit-event-title"
        onClose={() => setOpen(false)}
        isLocked={isLocked}
        setIsLocked={setIsLocked}
        hasLock
        canBeEdited={
          meeting &&
          (meeting.status === 6 ||
            meeting.status === 7 ||
            meeting.status === 8 ||
            meeting.status === 1 ||
            meeting.status === 4)
        }
      >
        <Box
          alignSelf="center"
          color="InfoText"
          textOverflow="ellipsis"
          overflow="hidden"
          width="70%"
        >
          {meeting && meeting.topic ? `Edit ${meeting.topic}` : `Edit Event`}
        </Box>
      </CustomDialogTitle>
      <DialogContent
        dividers
        sx={{
          minHeight: 420,
          "& .MuiDialogContent-root": {
            p: 0,
          },
        }}
      >
        
        {children}
      </DialogContent>
      <DialogActions sx={{ display: "flex", justifyContent: "space-between" }}>
        {meeting &&
        (meeting.status === 6 ||
          meeting.status === 1 ||
          meeting.status === 2 ||
          meeting.status === 7 ||
          meeting.status === 4) ? (
          <Button
            variant="outlined"
            color="success"
            sx={{ mr: 1 }}
            startIcon={<VerifiedRoundedIcon />}
            disabled={!meeting || !meeting?.id || !isLocked}
            component={LinkBehavior}
          />
        ) : (
          <Button
            variant="outlined"
            color="error"
            sx={{ mr: 1 }}
            startIcon={<Close fontSize="small" />}
            onClick={() => setOpen(false)}
          >
            Close
          </Button>
        )}
        <Button
          variant="contained"
          type="submit"
          sx={{ mr: 1 }}
          startIcon={<EventAvailable />}
          disabled={!meeting || !meeting?.id || isLocked}
          onClick={() => handleSubmit()}
        >
          EDIT EVENT
        </Button>
      </DialogActions>
    </Dialog>
  );
}

//@ts-expect-error
export default withRouter(EditEventWindowDialog);
